import React from 'react';

// Shared with the token back so the inspector uses the same shapes.
export const MONSTER_TOUGHNESS_PATH = 'M0 -24 C-12 -6 -20 8 -20 20 C-20 32 -12 40 0 40 C12 40 20 32 20 20 C20 8 12 -6 0 -24 Z';
export const MONSTER_COMBAT_DAMAGE_PATH = 'M156 185 C141 173 133 163 141 155 C147 149 154 152 156 160 C158 152 165 149 171 155 C179 163 171 173 156 185 Z';

export function MonsterStatIcon({ kind, value }: { kind: 'Toughness' | 'Combat damage' | 'Horror damage'; value: number | string | undefined }) {
  return <svg className="monster-stat-icon" viewBox="0 0 48 48" role="img" aria-label={`${kind}: ${value}`}>
    {kind === 'Toughness' ? <path d={MONSTER_TOUGHNESS_PATH} transform="translate(24 19) scale(.65)" fill="#b9151b" stroke="white" strokeWidth="3" />
      : kind === 'Combat damage' ? <path d={MONSTER_COMBAT_DAMAGE_PATH} transform="translate(-147.6 -158) scale(1.1)" fill="#b9151b" stroke="white" strokeWidth="2" />
      : <ellipse cx="24" cy="25" rx="22" ry="17" fill="#1258c9" stroke="white" strokeWidth="2" />}
    <text x="24" y="31" textAnchor="middle" fill="white" fontFamily="system-ui, sans-serif" fontWeight="700" fontSize={String(value).length > 2 ? 12 : 18}>{value === 'Special' ? 'S' : value}</text>
  </svg>;
}
